import React, { useEffect, useState } from 'react';
import { Grid, pn, useElementBreakpoints } from '@compass/core';
import { Select } from 'components';
import {
    StudentFilter as StudentFilterModel,
    StudentFilterResource,
    LkStudentDisplayFilterId,
} from 'generated/openApi';
import { useStudentData } from '../contexts/StudentDataContext';
import ApiService from 'services/apiService';
import produce from 'immer';

export const StudentFilterControls = () => {
    const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
    const { filter, updateFilter, activeSchoolYear } = useStudentData();

    const [resource, setResource] = useState<StudentFilterResource>({} as StudentFilterResource);
    const properties = resource.properties || [];

    useEffect(() => {
        ApiService.students.getFilterResource().then((response) => {
            setResource(response);
        });
    }, []);

    const schoolYearField = () => {
        const propertyName = pn<StudentFilterModel>("schoolYears");
        const property = properties.find((x) => x.propertyName === propertyName);

        return (
            <Select
                modelProperty={property}
                value={resource.schoolYearsWithActive?.find((x) => x.id === (filter.schoolYear ?? activeSchoolYear))}
                options={resource.schoolYearsWithActive}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => updateFilter({ schoolYear: value?.id ?? null })}
            />
        );
    };

    const programField = () => {
        const propertyName = pn<StudentFilterModel>("programIds");
        const property = properties.find((x) => x.propertyName === propertyName);

        return (
            <Select
                modelProperty={property}
                value={resource.programs?.find((x) => x.id === filter.programId)}
                options={resource.programs}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => updateFilter({ programId: value?.id ?? null })}
            />
        );
    };

    // Check if tenant should see the program filter
    const showProgramFilter = resource.displayFilters?.some(
        x => x.id === LkStudentDisplayFilterId.Program
    );

    if (!resource.schoolYearsWithActive?.length) {
        return null;
    }

    return (
        <Grid ref={breakpointsRef} container spacing="sm" sx={{ mb: 2 }}>
            <Grid item xs={smallFieldBreakpoints}>
                {schoolYearField()}
            </Grid>

            {showProgramFilter && (
                <Grid item xs={smallFieldBreakpoints}>
                    {programField()}
                </Grid>
            )}
        </Grid>
    );
};